import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import { router } from "@/router";
import { i18n } from "@/plugins/i18n";
import { installPrimeVue } from "@/plugins/primevue";

import "primeicons/primeicons.css";
import "@/styles/global.css";

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);
installPrimeVue(app);
app.mount("#app");
